// removed by extract-text-webpack-plugin
module.exports = {"Base":"RecentComments__Base-28DT_","Link":"RecentComments__Link-rC5K0","Content":"RecentComments__Content-13frI","CommentCount":"RecentComments__CommentCount-1MEWh","Articles":"RecentComments__Articles-1UUL0","Article":"RecentComments__Article-1UiPf","Username":"RecentComments__Username-2sWcL","Icon":"RecentComments__Icon-6YW0W","Title":"RecentComments__Title-U5Vlb RecentComments__Username-2sWcL"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/RecentComments/RecentComments.css
 ** module id = 638
 ** module chunks = 0
 **/